export const useAzureBlob = () => {
  const uploadFileOnBlob = async ({sasToken, directory}, file) => {
    if (!sasToken || !directory || !file) return
    // input / inbound / product / mexico
    // const VITE_BLOB_URL = "https://rewards-b2b.dev.mypepsico.com/blob/input/inbound/sales_target"
    // blob / input / inbound / product / mexico
    const blob_url = import.meta.env.VITE_BLOB_HOST_URL
    const uploadUrl = `${blob_url}${directory}${file?.name}?${sasToken}`
    try {
      const response = await fetch(uploadUrl, {
        method: 'PUT',
        headers: {
          'x-ms-blob-type': 'BlockBlob',
          'Content-Type': file?.type,
        },
        body: file,
      })

      if (!response.ok) {
        throw new Error('Upload failed')
      }

      return true
    } catch (error) {
      console.error('Error uploading file:', error)
      return error
    }
  }

  return {uploadFileOnBlob}
}
